import React, { useState, useEffect, useRef } from 'react';
import FocusLock from 'react-focus-lock';
import Modal from '../modal/modal';
import Overlay from '../overlay/overlay';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import WelcomeOfferContent from './welcome-offer-content';
import { getCookie, setCookie } from '../utils/cookie-functions';
import isConsentGranted, { isOneTrustModalBannerUp } from '../utils/consent-check';
import { addNoScroll, removeNoScroll } from '../utils/modal';

const WelcomeOfferModal = ({
  blocks,
  enableSMS,
  customer,
  enableLogo,
  thinxLogo,
  noThanksMessage,
  SuccessMessage,
  SuccessMessageText,
  KeepShoppingBtnTxt,
  KeepShoppingBtnLink,
  DisclaimerErrorMessage,
  ConsentErrorMessage
}) => {

  const emailBlock = blocks.find(block => block.type === 'email')?.settings || {};
  const smsBlock = blocks.find(block => block.type === 'sms')?.settings || {};
  const isSMSEnabled = enableSMS;
  const isLogoEnabled = enableLogo;
  const [showModal, setShowModal] = useState(false);
  const [content, setContent] = useState('email');

  const isMounted = useRef(true);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  useEffect(() => {
    isMounted.current = true;

    const purchasedCookie = getCookie('_purchased');
    const purchasedModalShown = sessionStorage.getItem('purchasedModalShown');
    const submittedWelcomeModal = getCookie('_submittedWelcomeModal');

    const shouldShowModal = () => {
      return (
        ((customer.id && customer.orders_count === 0) || !customer.id) &&
        (purchasedCookie !== 'true' || !purchasedCookie) &&
        !purchasedModalShown &&
        !submittedWelcomeModal
      );
    };

    let interval;

    const startTimer = () => {
      interval = setInterval(() => {
        if (!isOneTrustModalBannerUp() && isMounted.current) {
          openModal();
          sessionStorage.setItem('purchasedModalShown', 'true');
          clearInterval(interval);
        }
      }, 5000);
    };

    if (shouldShowModal()) {
      if (!isOneTrustModalBannerUp()) {
        startTimer();
      }
    }

    const observer = new MutationObserver(() => {
      if (isOneTrustModalBannerUp()) {
        if (interval) {
          clearInterval(interval);
        }
      } else if (!interval && isMounted.current && shouldShowModal()) {
        startTimer();
      }
    });

    if (!purchasedModalShown) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    return () => {
      isMounted.current = false;
      if (interval) {
        clearInterval(interval);
      }
      observer.disconnect();
    };
  }, [customer]);

  useEffect(() => {
    const preventDefault = (e) => e.preventDefault();

    if (showModal) {
      addNoScroll();
    } else {
      removeNoScroll();
    }

    return () => {
      document.body.removeEventListener('touchmove', preventDefault);
    };
  }, [showModal]);

  useEffect(() => {
    const targetingConsent = isConsentGranted('C0004');
    if (content === 'confirmation' && targetingConsent) {
      setCookie('_submittedWelcomeModal', 'true');
    }
  }, [content]);

  return (
    <>
      {showModal && (
        <Overlay closeModal={closeModal}>
          <FocusLock>
            <Modal
              closeModal={closeModal}
              enableLogo={isLogoEnabled}
              thinxLogo={thinxLogo}
              classNames="bg-brand-light-beige"
            >
              <WelcomeOfferContent
                enableSMS={isSMSEnabled}
                smsContent={smsBlock}
                emailContent={emailBlock}
                noThanksMessage={noThanksMessage}
                content={content}
                setContent={setContent}
                closeModal={closeModal}
                SuccessMessage={SuccessMessage}
                SuccessMessageText={SuccessMessageText}
                KeepShoppingBtnTxt={KeepShoppingBtnTxt}
                KeepShoppingBtnLink={KeepShoppingBtnLink}
                DisclaimerErrorMessage={DisclaimerErrorMessage}
                ConsentErrorMessage={ConsentErrorMessage}
              />
            </Modal>
          </FocusLock>
        </Overlay>
      )}
    </>
  );
};

export default WelcomeOfferModal;
